export const AGENDAMENTO_STORE = 'agendamento';
